import $ from 'jquery';

export default function Store(vm) {
    this.all = function(params) {
        var url = '/store/list?' + $.param(params);

        return vm.get(url);
    };

    this.create = function(params) {
        var url = '/store/create';

        return vm.post(url, params);
    };

    this.get = function(id) {
        var url = '/store/detail/' + id;

        return vm.get(url);
    };

    this.delete = function(params) {
        var url = null;

        if (params.is_permanent == 1)
            url = '/store/force-delete/' + params.id;
        else
            url = '/store/delete/' + params.id;

        return vm.delete(url);
    };

    this.restore = function(id) {
        var url = '/store/restore/' + id;

        return vm.get(url);
    };
}